import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { EnhancedElement } from 'app/shared/lib/aurelia';
import { autoinject } from 'aurelia-framework';

@autoinject()
export abstract class CustomAttributeBase {
    protected element: EnhancedElement;
    constructor(element: Element, protected readonly logger: AppLogger) {
        this.element = element as EnhancedElement;
    }
}
